import { Box, Button, Typography } from "@mui/material";
import React from "react";
import WarningIcon from '@mui/icons-material/Warning';

export default function PageNotFound() {
    const theme = localStorage.getItem('theme') || 'light';
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: theme === 'light' ? '#F9F9FE' : '#192841' }}>
            <WarningIcon color="warning" sx={{ fontSize: 100, marginBottom: 2 }} />
            <Typography variant="h3" 
            sx={{ marginBottom: 2, textAlign: 'center', fontFamily: 'Trebuchet MS', width: '100%', fontSize: 'clamp(1.5rem, 1.5rem, 1.5rem)', color: theme === 'light' ? '#000' : '#fff' }}>Page not found.</Typography>
            <Button variant="text" color="primary" sx= {{ textTransform: 'capitalize', fontSize: 'clamp(1rem, 1rem, 1rem)' }} onClick={() => window.location.href = '/'}>Go to Dashboard</Button>
        </Box>
    )
}